import React, { useState, useRef, useEffect } from "react";
import { NavLink } from "react-router-dom";

function CustomerNavbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => {
    setIsMenuOpen((prevState) => !prevState);
  };

  const headerRef = useRef(null);

    // Close menu when clicking outside header
        useEffect(() => {
          const handleClickOutside = (event) => {
            if (
              headerRef.current &&
              !headerRef.current.contains(event.target)
            ) {
              setIsMenuOpen(false);
            }
          };
      
          document.addEventListener("click", handleClickOutside);
          return () => document.removeEventListener("click", handleClickOutside);
        }, []);

  return (
    <React.Fragment>
      <header ref={headerRef}>
        <section className="nav-section-customer">
          <nav className="main-navbar">
          <NavLink to="/" className>
            <div className="logo">
              <img
                src="assets/images/credence-pay-logo.png"
                alt="Logo"
                width="auto"
              />
            </div>
            </NavLink>
            <div className="main-menu-toggle" onClick={toggleMenu}>
              ☰
            </div>
            <ul className={`main-nav-links ${isMenuOpen ? "active" : ""}`}>
              <li>
                <NavLink to="/" className>
                  Home
                </NavLink>
              </li>
              <li>
                <NavLink to="/About-Us" >
                  About Us
                </NavLink>
              </li>
              {/* <li>
                <NavLink to="/FAQ" >
                  FAQs
                </NavLink>
              </li> */}
              <li>
                <NavLink to="/Privacy-Policy" >
                  Privacy
                </NavLink>
              </li>
              <li>
                <NavLink to="/Contact-Us" >
                  Contact
                </NavLink>
              </li>
            </ul>
          </nav>
        </section>
      </header>
    </React.Fragment>
  );
}

export default CustomerNavbar;
